'use client';

import { c as _c } from "react/compiler-runtime";
import type { CreditRangeEnum } from '@cc-shopping/contracts/credit-cards-page/roundup/utils';
import type { MultiSelectOption } from '@cc-shopping/ui/composites/MultiSelectDropdown';
import type { SingleSelectOption } from '@cc-shopping/ui/composites/SingleSelectDropdown';
import { useMemo } from 'react';
import { useShallow } from 'zustand/shallow';
import { CARD_FEATURES_OPTIONS, CREDIT_RANGE_OPTIONS_LABEL_MAP, SORT_BY_OPTIONS } from '../../config';
import { useOffersFilterStore } from '../../store/Context';
import type { OffersFilterStoreState } from '../../store/types';
export type CardFeaturesOption = {
  label: string;
  value: string;
};
export type SortByOption = {
  label: string;
  value: string;
};
export type DesktopFilterOptions = {
  creditRangeOptions: MultiSelectOption[];
  cardFeaturesOptions: SingleSelectOption[];
  /** Map issuer ID to label (name) for displaying selected options */
  issuerIdToLabel: Record<string, string>;
  /** Map issuer label (name) to issuer ID for translating dropdown selection to store */
  issuerLabelToId: Record<string, string>;
  issuersOptions: MultiSelectOption[];
  sortByOptions: SingleSelectOption[];
};
export function useDesktopFilterOptions() {
  const $ = _c(22);
  const {
    preComputedFilterOfferIds,
    availableOffersCount
  } = useOffersFilterStore(useShallow(_temp));
  const issuerIdToLabel = preComputedFilterOfferIds.issuersIdNameMap;
  let issuerLabelToId;
  let t0;
  if ($[0] !== issuerIdToLabel) {
    issuerLabelToId = {};
    t0 = Object.entries(issuerIdToLabel).map(t1 => {
      const [id, name] = t1;
      issuerLabelToId[name] = id;
      return {
        id,
        name
      };
    });
    $[0] = issuerIdToLabel;
    $[1] = issuerLabelToId;
    $[2] = t0;
  } else {
    issuerLabelToId = $[1];
    t0 = $[2];
  }
  const issuerEntries = t0;
  let t1;
  if ($[3] !== issuerEntries || $[4] !== issuerIdToLabel || $[5] !== issuerLabelToId) {
    t1 = {
      issuerIdToLabel,
      issuerLabelToId,
      issuerEntries
    };
    $[3] = issuerEntries;
    $[4] = issuerIdToLabel;
    $[5] = issuerLabelToId;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const {
    issuerIdToLabel: issuerIdToLabel_0,
    issuerLabelToId: issuerLabelToId_0,
    issuerEntries: issuerEntries_0
  } = t1;
  let t2;
  if ($[7] !== availableOffersCount?.creditRange || $[8] !== preComputedFilterOfferIds.offersByRCSMap) {
    let t3;
    if ($[10] !== availableOffersCount?.creditRange) {
      t3 = (acc, t4) => {
        const [key, value] = t4;
        const typedKey = key as CreditRangeEnum;
        if (value.size > 0) {
          acc.push({
            label: CREDIT_RANGE_OPTIONS_LABEL_MAP[typedKey],
            count: availableOffersCount?.creditRange?.[typedKey] ?? 0
          });
        }
        return acc;
      };
      $[10] = availableOffersCount?.creditRange;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    t2 = Object.entries(preComputedFilterOfferIds.offersByRCSMap).reduce(t3, []);
    $[7] = availableOffersCount?.creditRange;
    $[8] = preComputedFilterOfferIds.offersByRCSMap;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const creditRangeOptions = t2;
  let t3;
  if ($[12] !== availableOffersCount?.issuers || $[13] !== issuerEntries_0) {
    let t4;
    if ($[15] !== availableOffersCount?.issuers) {
      t4 = t5 => {
        const {
          id: id_0,
          name: name_0
        } = t5;
        return {
          label: name_0,
          count: availableOffersCount?.issuers?.[id_0] ?? 0
        };
      };
      $[15] = availableOffersCount?.issuers;
      $[16] = t4;
    } else {
      t4 = $[16];
    }
    t3 = issuerEntries_0.map(t4);
    $[12] = availableOffersCount?.issuers;
    $[13] = issuerEntries_0;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  const issuersOptions = t3;
  let t4;
  if ($[17] !== creditRangeOptions || $[18] !== issuerIdToLabel_0 || $[19] !== issuerLabelToId_0 || $[20] !== issuersOptions) {
    t4 = {
      creditRangeOptions,
      cardFeaturesOptions: CARD_FEATURES_OPTIONS,
      issuerIdToLabel: issuerIdToLabel_0,
      issuerLabelToId: issuerLabelToId_0,
      issuersOptions,
      sortByOptions: SORT_BY_OPTIONS
    };
    $[17] = creditRangeOptions;
    $[18] = issuerIdToLabel_0;
    $[19] = issuerLabelToId_0;
    $[20] = issuersOptions;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  return t4;
}
function _temp(state) {
  return {
    preComputedFilterOfferIds: state.preComputedFilterOfferIds,
    availableOffersCount: state.availableOffersCount
  };
}